export const actionItemsData = {
  total: 1,
  limit: 10,
  skip: 0,
  data: [
    {
      id: 1630,
      description: 'Sign note',
      dueDate: '2022-03-16T19:16:57.285Z',
      isProgressNotes: true,
      firstName: 'Elen',
      lastName: 'Degory',
      email: 'royan+testelen@intellihealthcorp.com',
      'patient.id': 6649,
      'patient.wellnessVision': null,
      'patient.enrollmentDate': '2022-03-11T17:22:58.485Z',
      'patient.isUpdatesMsgShown': false,
      'patient.lastContact': '2022-03-16T19:17:21.815Z',
      'patient.hasMedications': true,
      'patient.hasDiagnoses': false,
      'patient.hasSymptoms': false,
      'patient.hasAllergies': false,
      'patient.aomCheckDate': null,
      'patient.createdAt': '2022-03-11T17:22:58.485Z',
      'patient.updatedAt': '2022-06-06T10:05:00.568Z',
      'patient.userId': 8541,
      'patient.createdBy': 2632,
      'patient.updatedBy': 248,
      'patient.programId': 1,
      'patient.patientGoalId': null,
    },
  ],
};
